import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/consent";
import { trackPageview } from "@/lib/analytics";

export const CookieBanner = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === null) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  if (!visible || pathname.startsWith("/admin")) return null;

  const accept = () => {
    setConsent("accepted");
    setVisible(false);
    trackPageview(pathname); // comptabilise la page courante une fois accepté
  };
  const refuse = () => {
    setConsent("refused");
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6"
    >
      <div className="mx-auto max-w-4xl border border-white/10 bg-[#0f1524]/95 backdrop-blur-md shadow-2xl p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={20} className="text-teal-300 shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm leading-relaxed text-slate-300">
            Nous utilisons un outil de <strong className="text-slate-100">mesure d'audience</strong> interne
            pour améliorer ce site. Vous pouvez l'accepter ou le refuser. Aucun traceur publicitaire n'est utilisé.{" "}
            <Link to="/confidentialite" className="text-teal-400 hover:text-teal-300 underline underline-offset-2" data-testid="cookie-banner-privacy-link">
              En savoir plus
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={refuse}
            data-testid="cookie-refuse-btn"
            className="text-xs sm:text-sm px-4 py-2.5 border border-white/15 text-slate-300 hover:border-white/30 hover:text-slate-100 transition-colors"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="btn-primary !px-5 !py-2.5 text-xs sm:text-sm"
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
};
